import { Box, BoxProps, Paper } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useIsMobile } from '../../../contexts'
import { ContentProps, TableContentProps } from '../types'
import { filterColumns } from '../helpers'
import { MobileContent } from './mobile-content'
import { DesktopContent } from './desktop-content'

const useStyles = makeStyles((theme) => ({
  desktopWrapper: {
    width: '100%'
  },
  desktopBox: {
    padding: 0
  },
  mobileWrapper: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      padding: 0
    }
  },
  mobileBox: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row'
    }
  }
}))

export const TableContent = <RowDataType,>({
  data,
  cellProps,
  className,
  tableStylingProps,
  ...rest
}: TableContentProps<RowDataType>) => {
  const classes = useStyles()
  const isMobile = useIsMobile()

  const customClassName = className || ''
  const paperClassName = `${
    isMobile ? classes.mobileWrapper : classes.desktopWrapper
  } ${customClassName}`

  const boxProps: BoxProps = isMobile
    ? { className: classes.mobileBox }
    : {
        className: classes.desktopBox,
        display: 'flex',
        flexDirection: 'row',
        p: 1
      }

  const contentProps: ContentProps<RowDataType> = {
    data: data,
    filtered: filterColumns(data, cellProps),
    tableStylingProps,
    ...rest
  }

  return (
    <Paper className={paperClassName} elevation={0} square>
      <Box {...boxProps}>
        {isMobile ? (
          // MOBILE
          <MobileContent {...contentProps} />
        ) : (
          // DESKTOP
          <DesktopContent {...contentProps} />
        )}
      </Box>
    </Paper>
  )
}
